import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Button, Card, CardBody, CardHeader,Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown} from 'react-icons/fa';
import uuid from 'react-uuid';
import toast, { Toaster } from 'react-hot-toast'; import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const WaterwayFencingSummary = ({ userId }) => {
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [isOpen, setIsOpen] = useState(false);
    const [isIconUp, setIsIconUp] = useState(false);
    const [loading, setLoading] = useState(true);
    const [waterwayFencing, setWaterwayFencing] = useState({summaryList: [] });
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/summary/GetWaterwayFencingDetails/', {
                params: {
                    farmId: farmId
                }
            }
            );
            setWaterwayFencing({
                ...waterwayFencing, summaryList: response.data
            });
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    }

    const exportWaterwayFencingOverall = async (e,type) => {
        e.stopPropagation();
        e.preventDefault();
        const response = handleWaterwayFencingOverallReport(e,type);
        toast.promise(response, {
            loading: 'Generating report...',
            success: 'Report generated!',
            error: 'Error when generating report',
        });
    }

    const handleWaterwayFencingOverallReport = async (e, type) => {
        const response = await apiGet(
            '/api/Summary/GenerateReportWaterwayFencingOverall/', {
                params: { farmId: farmId,type:type }
        })

        if (response.data.status) {
            var buffer = base64ToArrayBuffer(response.data.content)
            if (type == "Pdf") {
                var file = new Blob([buffer], { type: "application/pdf" })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(file)
                link.download = "WaterwayFencingOverall.pdf";
            }
            else {
                var file = new Blob([buffer], { type: "application/vnd.ms-excel" })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(file)
                link.download = "WaterwayFencingOverall.xlsx";
            }
            document.body.appendChild(link)
            link.click()
        }

    }

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    return (
        <Card className="my-4">
            <CardHeader className="card-header-dark-click" onClick={toggle}>
                <Row>
                    <Col sm="11"><h6>Waterway Fencing (Overall)
                        <Button className="excelIcon" onClick={(e) => exportWaterwayFencingOverall(e,'Excel')} value="Export" placeholder="">
                            <img src="/images/Excel_icon.png" className="card_icon" ></img>
                        </Button>
                        <Button className="pdfIcon" onClick={(e) => exportWaterwayFencingOverall(e,'Pdf')} value="Export" placeholder="">
                            <img src="/images/PDF_icon.png" className="card_icon" ></img>
                        </Button>                    </h6></Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody >
                    <Row>
                        <Col>
                            {!loading &&
                                <table id="tblWaterwayFencingSummary" className="table borderless table-striped border-top-bottom">
                                    <thead className="textAlignCenter">
                                        <tr>
                                            <th rowSpan="2" style={{ textAlign: 'left' }}>Type</th>
                                            <th colSpan="1" style={{ textAlign: 'left' }}>Length or Perimeter</th>
                                            <th colSpan="2" style={{ textAlign: 'left' }}>Fenced</th>
                                            <th colSpan="2" style={{ textAlign: 'left' }}>UnFenced</th>
                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: 'left' }}>km</th>
                                            <th style={{ textAlign: 'left' }}>km</th>
                                            <th style={{ textAlign: 'left' }}>%</th>
                                            <th style={{ textAlign: 'left' }}>km</th>
                                            <th style={{ textAlign: 'left' }}>%</th>
                                        </tr>
                                    </thead>
                                    <tbody className="waterwayFencingSummaryList textAlignCenter" id="waterwayFencingSummaryList">
                                        {waterwayFencing.summaryList.map(summary => 

                                            <tr key={uuid()}>
                                                <td style={{ textAlign: 'left' }}>{summary.type}</td>
                                                <td style={{ textAlign: 'left' }}>{summary.totalKm == 0 ? "" : summary.totalKm}</td>
                                                <td style={{ textAlign: 'left' }}>{summary.fencedKm == 0 ? "" : summary.fencedKm}</td>
                                                <td style={{ textAlign: 'left' }}>{summary.fencedPerc == 0 ? "" : summary.fencedPerc}</td>
                                                <td style={{ textAlign: 'left' }}>{summary.unFencedKm == 0 ? "" : summary.unFencedKm}</td>
                                                <td style={{ textAlign: 'left' }}>{summary.unFencedPerc == 0 ? "" : summary.unFencedPerc}</td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                </table>
                            }
                        </Col>
                    </Row>

                </CardBody>
            </Collapse>
        </Card>
    )
}
export default WaterwayFencingSummary

